import PropTypes from 'prop-types';

const propTypes = {  
  oAuthUser: PropTypes.shape({
    email: PropTypes.string,
    familyName: PropTypes.string,
    gender: PropTypes.string,
    givenName: PropTypes.string,
    hd: PropTypes.string,
    id: PropTypes.string,
    link: PropTypes.string,
    locale: PropTypes.string,
    name: PropTypes.string,
    picture: PropTypes.string,
    isVerified: PropTypes.bool,
  }),
};

export default propTypes;